
import * as angular from "angular";
import { GeofenceCategory, IGeofence } from "@interfaces/IGeofences";
import { IPlot } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { GeofenceService } from "@services/geofence.service";

import "./nearestGeofences.scss";

interface IPlotInfoCardComponentComponent {
    plot: IPlot;
    latLng: google.maps.LatLng;
    onGeofenceClicked: (args: { geofence: IGeofence }) => void;
}

interface IGeofenceDistance {
    geofence: IGeofence;
    distance: number;
    roundedDistance: number;
}

class NearestGeofencesComponentController implements angular.IComponentController, IPlotInfoCardComponentComponent {

    plot: IPlot;
    latLng: google.maps.LatLng;
    onGeofenceClicked: (args: { geofence: IGeofence }) => void;

    nearestGeofences: IGeofenceDistance[] = [];
    loading = false;

    numResultsToShow = 5;
    maxDistance = 10;

    static $inject = ["$mdMedia", "geofenceService"];

    constructor(
        private readonly $mdMedia: angular.material.IMedia,
        private readonly geofenceService: GeofenceService) {
    }

    $onInit() {
        if (this.$mdMedia("max-height: 850px")) {
            this.numResultsToShow = 3;
        }
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {

        if (this.plot) {
            this.latLng = new google.maps.LatLng(this.plot.Latitude, this.plot.Longitude);
        }

        if (this.latLng) {
            this.updateNearestGeofences();
        }
    }

    geofenceClicked(geofence: IGeofence) {
        if (this.onGeofenceClicked) {
            this.onGeofenceClicked({ geofence: geofence });
        }
    }

    // -----------------------

    private updateNearestGeofences() {

        this.loading = true;

        this.geofenceService.getGeofences()
            .then(geofences => {
                geofences = geofences.filter(g => g.Category == GeofenceCategory.Standard);

                performance.mark("nearestGeofences");

                this.nearestGeofences = [];
                //var vehicleLatLng = this.latLng;

                // Create distances
                for (var i = 0; i < geofences.length; i++) {
                    const geofence = geofences[i];

                    var center = new google.maps.LatLng(geofence.Latitude, geofence.Longitude);
                    var dist = google.maps.geometry.spherical.computeDistanceBetween(this.latLng, center);
                    const roundedDistance = Math.round(dist / 1000);

                    if (roundedDistance < this.maxDistance) {
                        this.nearestGeofences.push({
                            geofence: geofence,
                            distance: dist,
                            roundedDistance: roundedDistance // convert from metres to km
                        });
                    }                   
                }

                this.nearestGeofences.sort((a, b) => {
                    return a.distance > b.distance ? 1 : -1;
                });

                performance.measure("nearestGeofences");

                this.nearestGeofences = this.nearestGeofences.slice(0, this.numResultsToShow);
            })
            .finally(() => {
                this.loading = false;
            });
    }
}

export class NearestGeofencesComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            plot: "<",
            latLng: "<",
            onGeofenceClicked: "&"
        };

        this.controller = NearestGeofencesComponentController;
        this.template = require("./nearestGeofences.html");
    }
}
